
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination/[continent]/[country]/[region]/[resort]",
      function () {
        return require("private-next-pages/destination/[continent]/[country]/[region]/[resort]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination/[continent]/[country]/[region]/[resort]"])
      });
    }
  